import React from 'react';
import '../styles/Trabajos.css';
import '../styles/index.css';
import '../styles/main.css';


const Hero = ({ image, title, description }) => {
  return (
    <div className="container my-5">
      <div className="row hero">
        <img
          className="hero-image w-100"
          src={"/images/HeroTrabajos.png"}
          alt="Imagen de fondo"
        />
        <div className="hero-content position-absolute top-50 start-50 translate-middle text-center">
          <h1 dangerouslySetInnerHTML={{ __html: title }} />
          <p dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
    </div>
  );
};

export default Hero;
